<template>
  <div class="istatistics-interface">
    <div class="content_wrapper">
      <div style="padding: 10px;">
        <el-date-picker
          style="width: 400px;"
          v-model="selectDate"
          type="daterange"
          align="right"
          unlink-panels
          :clearable='false'
          value-format="yyyy-MM-dd"
          range-separator="至"
          @change="changeDate"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-select v-model="id" placeholder="请选择" style="width: 300px;" @change="view">
          <el-option-group
            v-for="group in groups"
            :key="group.name"
            :label="group.name">
            <el-option
              v-for="item in group.options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-option-group>
        </el-select>
      </div>
      <div style="padding: 10px;height: calc(100% - 180px)">
        <div class="show_total">
          <span>{{showTotal}}</span>
        </div>
        <div class="nodata" v-if="nodata" :style="{width: '100%', height: '95%'}">暂未调用该类型接口</div>
        <div v-show="!nodata" id="myChart" v-loading="loading" :style="{width: '100%', height: '95%'}"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import statisticsService from '@/service/statisticsService'
export default {
  data () {
    return {
      selectDate: [],
      id: 0,
      groups: [],
      showTotal: '',
      loading: false,
      nodata: false
    }
  },
  async mounted () {
    //      this.drawLine();
    let toDate = new Date().Format(this.SysConstant.DATE_FORMATE)
    let fromDate = this.$util.getLast(-6)
    await this.fetchSelect()
    this.selectDate = [fromDate, toDate]
    this.view()
  },
  methods: {
    // 下拉框
    async fetchSelect () {
      try {
        let data = await statisticsService.fetchInterfaceData()
        if (data) {
          //
          let opts = {}
          let keys = []
          let _groups = []
          this.id = data[0].id
          for (let item of data) {
            if (item.resource && item.resource.name && !opts[item.resource.name]) {
              opts[item.resource.name] = []
              keys.push(item.resource.name)
            }
            opts[item.resource.name].push({
              id: item.id,
              name: item.name
            })
          }
          for (let key of keys) {
            _groups.push(
              {
                name: key,
                options: opts[key]
              }
            )
          }
          this.groups = _groups
        } else {
          data = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async changeDate (dates) {
      await this.view()
    },
    async view () {
      this.loading = true
      let params = {
        id: this.id,
        fromDate: this.selectDate[0],
        toDate: this.selectDate[1]
      }
      try {
        let data = []
        this.showTotal = ''
        let chartData = {
          x: [],
          y: []
        }
        data = await statisticsService.fetchInterfaceDetailData(params)
        if (data && data.itemList) {
          for (let item of data.itemList) {
            chartData.x.push(item.localDate)
            chartData.y.push(item.count)
          }
          this.showTotal = '调用次数：' + data.count
          this.nodata = false
        } else {
          this.showTotal = '调用次数：0'
          this.nodata = true
        }
        this.drawLine(chartData)
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    drawLine (chartData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: chartData.x
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: chartData.y,
          type: 'line'
        }]
      }
      // 绘制图表
      myChart.setOption(option)
    }
  }
}
</script>
<style scoped>
  .istatistics-interface {
    padding: 15px 10px;
    height: 100%;
  }
  .istatistics-interface .content_wrapper{
    padding-left: 20px;
    padding-right: 10px;
    background-color: #ffffff;
    padding-top: 30px;
    height: 100%;
  }
  .istatistics-interface .content_wrapper .show_total {
    height: 40px;
    background-color: #F3F5F8;
    line-height: 40px;
    margin-top: 5px;
    color: #333333;
    font-weight: bold;
  }
  .istatistics-interface .content_wrapper .show_total span {
      margin-left: 30px;
  }
  .istatistics-interface .nodata{
    /* width: 100%;
    height: 200px; */
    text-align: center;
    line-height: 200px;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/istatistics/interface.vue